// Thin wrapper over the Google tag (gtag.js) loaded in public/index.html.
// Safe to call when the tag is blocked or missing; never pass emails or other PII as params.

type GtagWindow = Window & { gtag?: (...args: unknown[]) => void };

export function track(event: string, params: Record<string, unknown> = {}): void {
  try {
    (window as GtagWindow).gtag?.('event', event, params);
  } catch {
    /* analytics must never break the app */
  }
}

// Routes whose path carries a secret or invite token; the token must not reach GA.
const TOKEN_ROUTE = /^(\/login\/verify|\/link-invite|\/share-invite)\/[^/]+/;

export function trackPageView(pathname: string): void {
  const page_path = pathname.replace(TOKEN_ROUTE, '$1/:token');
  track('page_view', {
    page_path,
    page_location: window.location.origin + page_path,
    page_title: document.title,
  });
}
